import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";

let timeout: NodeJS.Timeout | null = null;

const state = () => ({
  isSnackbarActive: false,
  text: "",
  timeout: 4000,
  handler: null,
  color: "secondary"
});

const getters = {
  isSnackbarActive: (state: { isSnackbarActive: any }) =>
    state.isSnackbarActive,
  text: (state: { text: any }) => state.text,
  timeout: (state: { timeout: any }) => state.timeout,
  handler: (state: { handler: any }) => state.handler,
  color: (state: { color: any }) => state.color
};

const mutations = {
  [SnackbarMutationTypes.HIDE_SNACKBAR]: (state: {
    isSnackbarActive: boolean;
  }) => {
    state.isSnackbarActive = false;
    timeout && clearTimeout(timeout);
  },

  [SnackbarMutationTypes.SHOW_SNACKBAR]: (
    state: {
      isSnackbarActive: boolean;
      text: any;
      timeout: any;
      handler: any;
      color: any;
    },
    payload: { text: any; timeout: number; color: any; handler: any }
  ) => {
    const { text, timeout, handler, color } = payload;
    state.isSnackbarActive = true;
    state.text = text;
    state.timeout = timeout >= 0 ? timeout : state.timeout;
    state.handler = handler || null;
    state.color = color ? color : "secondary";
  }
};

const actions = {
  [SnackbarMutationTypes.HIDE_SNACKBAR]: (context: {
    commit: (arg0: string) => void;
  }) => {
    context.commit(SnackbarMutationTypes.HIDE_SNACKBAR);
  },

  [SnackbarMutationTypes.SHOW_SNACKBAR]: (
    context: {
      state: { timeout: number };
      commit: (arg0: string, payload: any) => void;
    },
    payload: any
  ) => {
    context.commit(SnackbarMutationTypes.HIDE_SNACKBAR, payload);
    context.commit(SnackbarMutationTypes.SHOW_SNACKBAR, payload);
    if (payload.timeout !== 0) {
      timeout = setTimeout(
        () => context.commit(SnackbarMutationTypes.HIDE_SNACKBAR, payload),
        payload.timeout || 4000
      );
    }
  }
};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
};
